module.exports = __webpack_public_path__ + "img/evse_item-v2.d2e9bd64.svg";